
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { AircraftSlider } from './components/AircraftSlider';
import { UseCases } from './components/UseCases';
import { News } from './components/News';
import { Technology } from './components/Technology';
import { SelectAircraft } from './components/SelectAircraft';
import { Footer } from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <Features />
      <News />
      <SelectAircraft />
      <AircraftSlider />
      <UseCases />
      <Technology />
      <Footer />
    </div>
  );
}
